import { render } from "./ContentblockMuseumIntroduction.vue?vue&type=template&id=c11db398&scoped=true&ts=true"
import script from "./ContentblockMuseumIntroduction.ts?vue&type=script&lang=ts"
export * from "./ContentblockMuseumIntroduction.ts?vue&type=script&lang=ts"

import "./ContentblockMuseumIntroduction.scss?vue&type=style&index=0&id=c11db398&lang=scss&scoped=true"

import exportComponent from "/Users/koenverbruggen/Sites/02-SITES/nederlandsmijnmuseum.local/wp-content/themes/nmm/js/vue/nmm/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c11db398"]])

export default __exports__